import Alpine from "alpinejs"
import { throttle } from 'throttle-debounce';

document.addEventListener('alpine:init', () => {
  Alpine.store('app', {
    /** True when any header menu is open */
    headerHasOpenMenu: false,
    /** True when the header is sticky */
    headerSticky: false,
    /** Sticky header Y position */
    headerStickyY: 16, // px
    /** True when underlay should be shown (for modals, etc.) */
    showUnderlay: false,
    /** Reactive viewport innerWidth */
    innerWidth: window.innerWidth,
    /** Returns true if the viewport is narrow */
    get narrow() {
      return this.innerWidth < this.narrowBreakpoint;
    },
    /** less than this value is considered narrow */
    narrowBreakpoint: 1024, // px
    /** True when the narrow menu is open */
    narrowMenuOpen: false,
    /** Scroll position */
    scrollY: window.scrollY,

    /**
     * Init
     */
    init() {
      window.addEventListener('scroll', throttle(100, this.handleScroll.bind(this)));
      window.addEventListener('resize', throttle(100, this.handleResize.bind(this)));

      // Initialize scrollY and innerWidth
      this.handleScroll();

      // Init sticky state based on initial scroll position
      this.headerSticky = window.scrollY > this.headerStickyY;
    },

    handleScroll() {
      // Update scrollY when scrolling
      this.scrollY = window.scrollY;
      this.headerSticky = this.scrollY > this.headerStickyY;
    },

    handleResize() {
      // Update innerWidth when resizing
      this.innerWidth = window.innerWidth;
      this.narrowMenuOpen = false; // Close narrow menu on resize
      document.documentElement.style.overflow = 'auto'; // Reset overflow
    },

    toggleMenu() {
      this.isMenuOpen = !this.isMenuOpen;
    },

    toggleMobileMenu() {
      this.narrowMenuOpen = !this.narrowMenuOpen;

      if (this.narrowMenuOpen) {
        document.documentElement.style.overflow = 'hidden';
      }
      else {
        document.documentElement.style.overflow = 'auto';
      }
    }
  });
});
